import "./css/app.css";
import info from "./assets/images/info.png";
import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import axios from "axios";
import Footer from "./partials/Footer";
import KashimaIcon from "./assets/images/kashima.png";
import Loading from "./assets/images/loading.gif";
import StringImage from "./assets/types/string.png";
import UserImage from "./assets/types/user.png";
import BooleanImage from "./assets/types/boolean.png";
import ChannelImage from "./assets/types/channel.png";
import RoleImage from "./assets/types/role.png";
import IntegerImage from "./assets/types/integer.png";
import NumberImage from "./assets/types/number.png";
import MentionableImage from "./assets/types/mentionable.png";
import AttachmentImage from "./assets/types/attachment.png";

const argumentTypes = {
    "3": {
        name: "String",
        description: "Any string",
        image: [StringImage]
    },
    "4": {
        name: "Integer",
        description: "Any integer between -2^53 and 2^53",
        image: [IntegerImage]
    },
    "5": {
        name: "Boolean",
        description: "Boolean, true / false",
        image: [BooleanImage]
    },
    "6": {
        name: "User",
        description: "Any guild's members",
        image: [UserImage]
    },
    "7": {
        name: "Channel",
        description: "Any guild's channels",
        image: [ChannelImage]
    },
    "8": {
        name: "Role",
        description: "Any guild's roles",
        image: [RoleImage]
    },
    "9": {
        name: "Mentionable",
        description: "Includes users and roles",
        image: [MentionableImage]
    },
    "10": {
        name: "Number",
        description: "Any double between -2^53 and 2^53",
        image: [NumberImage]
    },
    "11": {
        name: "Attachment",
        description: "Any file from you",
        image: [AttachmentImage]
    }
}

export default function App({match}) {
    const [layer, setLayer] = useState({
        active: true,
        type: "loading",
        message: ""
    })
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({
        invite: "https://discord.com/api/oauth2/authorize?client_id=424137718961012737&permissions=137744477510&scope=bot%20applications.commands",
        categories: []
    });
    const [masterCategory, setMasterCategory] = useState([]);
    const query = useRef();

    useEffect(() => {
        console.log(match)
        collectCommands().then(categories => {
            categories = Object.entries(categories);
            // setData(x => ({...x, categories: categories.filter(x => x !== "developer")}))
            setData(x => ({...x, categories: categories.filter(x => x[0] !== "developer")}))
            setMasterCategory(categories.filter(x => x[0] !== "developer"))
            setLoading(false);
            if (match.path.startsWith("/commands")) {
                const yFirst = [...document.getElementsByClassName("command-child")][0];
                if (!yFirst) return;
                window.scrollTo(0, yFirst.offsetTop);
            }
            if (match.path.startsWith("/category")) {
                const yFirst = document.getElementById(`category-${match.params.categoryName}`);
                if (!yFirst) return;
                window.scrollTo(0, yFirst.offsetTop);
            }
        })
        return () => void 0
    }, [])

    useEffect(() => {
        if (loading) setLayer({active: true, type: "loading", message: ""})
        else setLayer({active: false, type: "", message: ""})
    }, [loading]);

    async function collectCommands() {
        return new Promise(((resolve, reject) => {
            const source = axios.CancelToken.source();
            const timeout = setTimeout(() => {
                source.cancel();
                reject("Timed out");
            }, 15 * 1000);

            axios.get("https://raw.githubusercontent.com/Deivu/Kashima/master/assets/commands.json", {cancelToken: source.token})
                .then(async ({data, status}) => {
                    clearTimeout(timeout);
                    if (status !== 200) return resolve(await collectCommands())
                    resolve(data)
                }).catch(reject);
        }))
    }

    function renderTableData(args) {
        return args.map((cmd, index) => {
            const {name, description} = cmd //destructuring
            return (
                <tr key={index}>
                    <td>{name}</td>
                    <td>{description}</td>
                    <td>{cmd.args && Array.isArray(cmd.args) ? cmd.args.map(x => (
                        <a className="cmd-table-a" onClick={() => setLayer({
                            active: true,
                            type: "args",
                            message: `${x.type}`
                        })}>{x.name}</a>)) : "-"}</td>
                </tr>
            )
        })
    }

    function renderTableHeader() {
        return ["name", "description", "args"].map((key, index) => <th key={index}>{key.toUpperCase()}</th>)
    }

    function handleMainCommand(c, index) {
        return (<div className="command-child" key={index} id={`category-${c[0]}`}>
            <p className="command-child-title">{c[0].split("").map((s, i) => i === 0 ? s.toUpperCase() : s).join("")}</p>
            <div className="command-child-table">
                <table className="commands">
                    <tbody>
                    <tr>{loading ? "" : renderTableHeader()}</tr>
                    {loading ? "" : renderTableData(c[1])}
                    </tbody>
                </table>
            </div>
            <hr/>
        </div>)
    }

    function layerHandler(data) {
        const args = argumentTypes[data.message]
        // if (data.type === "loading") return (<div className="layer">
        //     <div className="layer-main layer-main-loading centered">
        //         <img src={loadingImage} alt="loading" />
        //         <p>Loading the commands...</p>
        //     </div>
        // </div>)
        if (data.type === "args" && args) return (
            <div className="layer" onClick={async () => {
                document.getElementsByClassName("layer")[0].classList.add("layer-out");
                await new Promise(r => setTimeout(r, 230));
                setLayer({active: false, type: "", message: ""})
            }}>
                <div className="layer-main centered">
                    <p className="layer-main-title">{args.name}</p>
                    <hr/>
                    <p className="layer-main-desc">{args.description}</p>
                    <div className="layer-main-images">
                        {args.image.map((x, i) => <img src={x} alt={args.name} key={i}/>)}
                    </div>
                    <p className="layer-main-hint">Click anywhere to close</p>
                </div>
            </div>)
    }


    function handleSearch(form, type) {
        const Query = query.current.value
        if (type === "submit") {
            form.preventDefault()
            query.current.value = "";
        }
        console.log(masterCategory)
        let result = Query ?
            masterCategory.filter(x => x[0].toLowerCase().includes(Query.trim())
                || x[1].some(c => c.name.toLowerCase().includes(Query.trim()))
                || x[1].some(c => c.description.toLowerCase().includes(Query.trim()))
                || x[1].args && x[1].some(c => c.args.some(a => a.name.includes(Query.trim())))
            )
            : masterCategory;

        if (Query) result = result.map(x => {
            let finalResult = x[1].filter(a => a.name.toLowerCase().includes(Query.trim())
                || a.description.toLowerCase().includes(Query.trim()))
            return [x[0], finalResult];
        })

        setData(x => ({...x, categories: result}))
    }

    return (<>
        <div className="header">
            <div className="header-content">
                <div className="header-application-name">
                    <img className="header-content-logo"
                         src={KashimaIcon}
                         alt="Kashima"/>
                    <p className="header-content-name">Kashima</p>
                </div>
                <div className={loading ? "header-search-bar header-search-bar-disabled" : "header-search-bar"}>
                    <form onSubmit={x => handleSearch(x, "form")}>
                        <input ref={query} type="text" onChange={x => handleSearch(x, "change")}
                               placeholder="Search here..."/>
                    </form>
                </div>
                <Link to="/about" className="header-buttons">
                    <img src={info} alt="Info"/>
                </Link>
            </div>
        </div>
        <div className="main-section">
            {layer.active ? layerHandler(layer) : ""}
            <div className="welcome">
                <p className="welcome-title">Welcome to Kashima Docs.</p>
                <hr/>
            </div>
            {loading ? <div className="loading">
                <img src={Loading} alt="loading"/>
            </div> : <div className="commands">
                {data.categories.map((c, i) => handleMainCommand(c, i))}
            </div>}

            <div className="back-to-top-btn" onClick={() => window.scrollTo(0, 0)}/>
        </div>
        <Footer/>
    </>);
}